module.exports = __webpack_public_path__ + "static/media/Group 48bubbles_around.9fdee17b.png";